import { render, staticRenderFns } from "./modalEditarProducto.vue?vue&type=template&id=6036286e&scoped=true"
import script from "./modalEditarProducto.vue?vue&type=script&lang=js"
export * from "./modalEditarProducto.vue?vue&type=script&lang=js"
import style0 from "./modalEditarProducto.vue?vue&type=style&index=0&id=6036286e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036286e",
  null
  
)

export default component.exports